// src/components/filtersModal.js
import { useState, useEffect } from "react";
import "../styles/filtersModal.css";

export default function GenericModal({
  title,
  isOpen,
  onClose,
  data = [],
  onSelect,
  loading = false   // ⬅️ NUEVO
}) {

  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(data);

  //BLOQUEAR SCROLL
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // RESET AL ABRIR
  useEffect(() => {
    setFilteredData(data);
    setSearchText("");
  }, [data, isOpen]);

  // 
  // const buildLabel = (item) => {
  //   return (
  //     item.label ??
  //     item.nombre ??
  //     item.NOMBRE ??
  //     item.descripcion ??
  //     item.sucursal ??
  //     item.SUCURSAL ??
  //     item.comprobante ??
  //     item.COMPROBANTE ??
  //     item.value ??
  //     JSON.stringify(item)
  //   );
  // };
const buildLabel = (item) => {

  return (

    // APERTURAS
    (item.CAPERTURA_CIERRE &&
      `Apertura #${item.CAPERTURA_CIERRE} - ${item.FECHA_APERTURA}`) ??

    // CAJAS
    item.CAJA ??
    item.caja ??

    // RUBRO + SUBRUBRO
    (item.rubro && item.subrubro &&
      `${item.rubro} - ${item.subrubro}`) ??

    // SUBRUBRO
    item.subrubro ??
    item.SUBRUBRO ??

    // RUBRO
    item.rubro ??
    item.RUBRO ??

    // CLIENTES
    item.CLIENTE ??
    item.cliente ??

    // USUARIOS
    item.USUARIO ??
    item.usuario ??

    // SUCURSALES
    item.SUCURSAL ??
    item.sucursal ??

    // RUTAS
    item.RUTA ??
    item.ruta ??

    // COMPROBANTES
    item.COMPROBANTE ??
    item.comprobante ??

    // GENÉRICOS
    item.nombre ??
    item.NOMBRE ??
    item.label ??
    item.descripcion ??
    item.value ??

    JSON.stringify(item)
  );
};

  // Handle search
  const handleSearch = (e) => {
    const text = e.target.value.toLowerCase();
    setSearchText(text);

    if (text.trim() === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter(item => {
      const label = buildLabel(item).toString().toLowerCase();
      return label.includes(text);
    });

    setFilteredData(filtered);
  };

  // Si el modal NO está abierto → no mostrar nada
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">

      {/* ------------ MODAL PRINCIPAL ------------ */}
      <div className="modal-box">

        <div className="modal-header">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}>X</button>
        </div>

        <input
          className="modal-search"
          type="text"
          placeholder="Buscar..."
          value={searchText}
          onChange={handleSearch}
        />

        <div className="modal-list">
          {filteredData.map((item) => {
          const key =
            item.id ??
            item.ID ??
            item.CCAJA ??
            item.CAPERTURA_CIERRE ??
            item.cCliente ??
            item.cUsuario ??
            item.cSucursal ??
            item.CSUCURSAL ??
            item.value ??
            JSON.stringify(item);

            return (
              <div
                key={key}
                className="modal-list-item"
                onClick={() => onSelect(item)}
              >
                {buildLabel(item)}
              </div>
            );
          })}

          {filteredData.length === 0 && (
            <div className="modal-list-item no-results">
              Sin resultados...
            </div>
          )}
        </div>

      </div>

      {/* ------------ MODAL DE CARGA ------------ */}
      {loading && (
        <div className="loading-modal-overlay">
          <div className="loading-modal-box">
            <p>Cargando datos...</p>
          </div>
        </div>
      )}
    </div>
  );
}
